import React, { ComponentProps } from "react";
import SnackbarZone from "../components/SnackbarZone";
import Modal from "./Modal";
import Notifications from "./Notifications";
import ScreenTitle from "./ScreenTitle";
import { useI18n } from "../hooks/i18n-hooks";
import VStack from "../ui_atoms/VStack";

type NotificationsModalProps = {
    onFinished: (result: boolean) => void;
} & ComponentProps<typeof Modal>;

const NotificationsModal = ({ onFinished, ...props }: NotificationsModalProps) => {
    const i18n = useI18n();

    return (
        <Modal {...props}>
            <VStack h="2/3" v={0.5}>
                <ScreenTitle>{i18n.t("screens.auth.notifications.title")}</ScreenTitle>
            </VStack>
            <Notifications onFinished={onFinished} />
            <SnackbarZone />
        </Modal>
    );
};

export default NotificationsModal;
